import React, { useEffect, useState } from "react";
import { handleMaskTelefonePJ, handleMaskCEPPJ, handleEnderecoPJ, handleMaskCNPJ } from "./functions";
import 'primeicons/primeicons.css';
import "./CadastroPJ.css";

import { ModalCadastroSocio } from "../modais/ModalCadastroSocio";
import { Input } from "../Input";
import { UsuarioPJ, Socios } from "../../pages/Cliente/Cadastro/Cadastro";
import { SelectEstado } from "../select/SelectEstados/SelectEstados";

interface CadastroPJProps {
    setUsuarioPJ: React.Dispatch<React.SetStateAction<UsuarioPJ>>,
    socios: Socios[],
    setSocios: React.Dispatch<React.SetStateAction<Socios[]>>,
}

function CadastroPessoaJuridica({ setUsuarioPJ, socios, setSocios }: CadastroPJProps) {
    const [modalCadastroSocio, setModalCadastroSocio] = useState<boolean>(false);

    const [CEP, setCEP] = useState<string>("");
    const [bairro, setBairro] = useState<string>("");
    const [cidade, setCidade] = useState<string>("");
    const [estado, setEstado] = useState<string>("");
    const [rua, setRua] = useState<string>("");
    const [complemento, setComplemento] = useState<string>("");

    const [maskTelefone, setMaskTelefone] = useState<string>("");
    const [maskCNPJ, setMaskCNPJ] = useState<string>("");
    const [maskCEP, setMaskCEP] = useState<string>("");

    const atualizarEnderecoPJ = (
        proximoEndereco: Partial<UsuarioPJ["endereco"]>
    ) => {
        setUsuarioPJ((usuario) => ({
            ...usuario,
            endereco: {
                rua,
                bairro,
                cep: CEP,
                cidade,
                complemento,
                estado,
                ...proximoEndereco,
            },
        }));
    };

    useEffect(() => {
        handleEnderecoPJ(setUsuarioPJ, rua, bairro, cidade, complemento, estado, CEP);
    }, [CEP, bairro, cidade, complemento, estado, rua, setUsuarioPJ]);

    const removerSocios = (indexDoSocio: number, socios: Socios[], setSocios: React.Dispatch<React.SetStateAction<Socios[]>>) => {
        const novaListaDeSocios = socios.filter(
            (socios, index) => indexDoSocio !== index
        );
        setSocios(novaListaDeSocios);
    };

    return (
        <div className="AreaCadastro">
            <div className="inputsCadastroPessoaJuridica dadosEmpresa">
                <Input
                    required={true}
                    placeholder="Nome da empresa"
                    label="Nome da empresa"
                    onChange={(e) => {
                        setUsuarioPJ((usuario) => ({ ...usuario, nome: e.target.value }));
                    }}
                />
                <Input
                    required={true}
                    placeholder="CNPJ"
                    label="CNPJ"
                    maxLength={18}
                    value={maskCNPJ}
                    onChange={(e) => { handleMaskCNPJ(e.target.value, setUsuarioPJ, setMaskCNPJ) }}
                />
                <Input
                    required={true}
                    placeholder="Razão Social"
                    label="Razão Social"
                    onChange={(e) => {
                        setUsuarioPJ((usuario) => ({ ...usuario, razaoSocial: e.target.value }));
                    }}
                />
                <Input
                    required={true}
                    placeholder=" "
                    label="Telefone"
                    maxLength={15}
                    value={maskTelefone}
                    onChange={(e) => { handleMaskTelefonePJ(e.target.value, setUsuarioPJ, setMaskTelefone) }}
                />
                <Input
                    required={true}
                    placeholder=" "
                    label="CEP"
                    maxLength={10}
                    value={maskCEP}
                    onChange={(e) => { handleMaskCEPPJ(e.target.value, setCEP, setRua, setBairro, setEstado, setCidade, setUsuarioPJ, setMaskCEP, rua, bairro, cidade, complemento, estado) }}
                />
                <div className="orgaoExpedidor">
                    <div className="inputMenor">
                        <Input
                            required={true}
                            placeholder=" "
                            label="Cidade"
                            value={cidade}
                            onChange={(e) => {
                                const novaCidade = e.target.value;
                                setCidade(novaCidade);
                                atualizarEnderecoPJ({ cidade: novaCidade });
                            }}
                        />
                    </div>
                    <SelectEstado
                        UF={estado}
                        onChange={(e) => {
                            const novoEstado = e.target.value;
                            setEstado(novoEstado);
                            atualizarEnderecoPJ({ estado: novoEstado });
                        }}
                    />
                </div>
                <Input
                    required={true}
                    placeholder=" "
                    label="Endereço"
                    value={rua}
                    onChange={(e) => {
                        const novaRua = e.target.value;
                        setRua(novaRua);
                        atualizarEnderecoPJ({ rua: novaRua });
                    }}
                />
                <Input
                    required={true}
                    placeholder=" "
                    label="Bairro"
                    value={bairro}
                    onChange={(e) => {
                        const novoBairro = e.target.value;
                        setBairro(novoBairro);
                        atualizarEnderecoPJ({ bairro: novoBairro });
                    }}
                />
                <Input
                    required={true}
                    placeholder=" "
                    label="Complemento e número"
                    value={complemento}
                    onChange={(e) => {
                        const novoComplemento = e.target.value;
                        setComplemento(novoComplemento);
                        atualizarEnderecoPJ({ complemento: novoComplemento });
                    }}
                />
            </div>

            <div className="inputsCadastroPessoaJuridica dadosSocios">
                <div className="socios-header">
                    <div>
                        <h6 className="titulo-lista-socios">Sócios</h6>
                        <span className="socios-opcional">Opcional</span>
                    </div>
                    <button
                        className="btn__laranja cadastro-pj-add-socio"
                        onClick={() => setModalCadastroSocio(true)}
                        type="button"
                        id="btnAdicionarSocio"
                    >
                        <i className="pi pi-plus"></i>
                        Adicionar sócio
                    </button>
                </div>

                <ModalCadastroSocio
                    modal={modalCadastroSocio}
                    setModal={() => setModalCadastroSocio(false)}
                    socios={socios}
                    setSocios={setSocios}
                />

                <div className="container-lista-socios">
                    {socios.length === 0 ? (
                        <p className="lista-socios-vazia">Nenhum sócio informado.</p>
                    ) : (
                        <ul className="lista-socios">
                            {socios.map(({ nome }, index) => (
                                <li key={`${nome}-${index}`} className="socio-item">
                                    <span>{nome}</span>
                                    <button
                                        className="botao-remover-socio"
                                        onClick={() => removerSocios(index, socios, setSocios)}
                                        type="button"
                                        aria-label={`Remover ${nome}`}
                                    >
                                        <i className="pi pi-trash"></i>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

            </div>
        </div>
    );
}

export default CadastroPessoaJuridica;
